import { storage } from '../firebase/config';
import { ref, getDownloadURL, getMetadata } from 'firebase/storage';

// Document references for Sadhana resources
const DOCUMENTS = {
  japJi: {
    path: 'documents/japjee__sohilaa_2014.pdf',
    title: 'Jap Ji Sahib & Sohila',
    description: 'The foundational morning prayer of Sikh Dharma and evening prayer'
  },
  kirtanSongs: {
    path: 'documents/Aquarian-Sadhana-Mantras-2020.pdf',
    title: 'Aquarian Sadhana Mantras',
    description: 'Sacred mantras and devotional songs used in our practice'
  }
};

/**
 * Get download URL for a document
 * @param {string} documentKey - Key from DOCUMENTS object
 * @returns {Promise<string>} Download URL
 */
export const getDocumentUrl = async (documentKey) => {
  try {
    const document = DOCUMENTS[documentKey];
    if (!document) {
      throw new Error(`Document ${documentKey} not found`);
    }

    const documentRef = ref(storage, document.path);
    const url = await getDownloadURL(documentRef);
    return url;
  } catch (error) {
    console.error(`Error getting document URL for ${documentKey}:`, error);
    throw error;
  }
};

/**
 * Get document metadata
 * @param {string} documentKey - Key from DOCUMENTS object
 * @returns {Promise<Object>} Document metadata
 */
export const getDocumentMetadata = async (documentKey) => {
  try {
    const document = DOCUMENTS[documentKey];
    if (!document) {
      throw new Error(`Document ${documentKey} not found`);
    }

    const documentRef = ref(storage, document.path);
    const metadata = await getMetadata(documentRef);

    return {
      ...document,
      size: metadata.size,
      updated: metadata.updated,
      contentType: metadata.contentType
    };
  } catch (error) {
    console.error(`Error getting document metadata for ${documentKey}:`, error);
    throw error;
  }
};

/**
 * Download a document
 * @param {string} documentKey - Key from DOCUMENTS object
 * @param {string} filename - Optional custom filename
 */
export const downloadDocument = async (documentKey, filename) => {
  try {
    const url = await getDocumentUrl(documentKey);
    const document = DOCUMENTS[documentKey];

    // Create a temporary link element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || `${document.title.toLowerCase().replace(/\s+/g, '-')}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(`Error downloading document ${documentKey}:`, error);
    throw error;
  }
};

/**
 * Open document in new tab
 * @param {string} documentKey - Key from DOCUMENTS object
 */
export const viewDocument = async (documentKey) => {
  try {
    const url = await getDocumentUrl(documentKey);
    window.open(url, '_blank');
  } catch (error) {
    console.error(`Error viewing document ${documentKey}:`, error);
    throw error;
  }
};

// Export document list for UI components
export const getAvailableDocuments = () => {
  return Object.keys(DOCUMENTS).map(key => ({
    key,
    ...DOCUMENTS[key]
  }));
};
